import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CalculationCompound } from '../../contracts';

export function contaminantNameValidator(compoundList: CalculationCompound[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) {
            return null;
        }

        const contaminants = compoundList.filter(c =>
            c.name.toLowerCase() === control.value.toLowerCase()
            || c.alternativeName.toLocaleLowerCase() === control.value.toLowerCase());

        if (contaminants && contaminants.length === 1) {
            return null;
        }

        return { contaminantName: { value: control.value } };
    };
}
